import PropTypes from 'prop-types';
import React from 'react';
import Tippy from '@tippyjs/react';
import { Button, Plus } from '@opendate-app/setlist';

const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

const hasVisibleText = (html) =>
  !!html && html.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').replace(/ /g, ' ').trim().length > 0;

const SeatInventoryRow = ({ row, color, onSelect, actionIcon, onHover }) => (
  <div
    className="seat-inventory-row"
    onMouseEnter={onHover ? () => onHover(row.zone) : undefined}
    onMouseLeave={onHover ? () => onHover(null) : undefined}
    onFocus={onHover ? () => onHover(row.zone) : undefined}
    onBlur={onHover ? () => onHover(null) : undefined}
  >
    <span className="seat-inventory-dot" style={{ background: color }} aria-hidden="true" />
    <span className="seat-inventory-body">
      <span className="seat-inventory-name">{row.name}</span>
      <span className="seat-inventory-sub">
        {row.sub}
        {hasVisibleText(row.description) ? (
          <Tippy
            content={<div className="seat-inventory-desc" dangerouslySetInnerHTML={{ __html: row.description }} />}
            interactive
            theme="light"
            maxWidth={280}
            appendTo={() => document.body}
          >
            <span className="seat-inventory-learn-more">
              <Button variant="link-color" size="sm">Learn more</Button>
            </span>
          </Tippy>
        ) : null}
      </span>
      {row.upcoming ? <span className="seat-inventory-sub">{row.upcoming}</span> : null}
    </span>
    {row.price != null ? (
      <span className="seat-inventory-price">
        {row.from_price ? 'From ' : null}{row.original_price != null ? <s className="mr-1">{currency.format(row.original_price)}</s> : null}
        {currency.format(row.price)}
      </span>
    ) : null}
    <Button
      variant="secondary"
      size="sm"
      icon={actionIcon || Plus}
      aria-label={`Select ${row.name}`}
      onClick={() => onSelect(row)}
    />
  </div>
);

SeatInventoryRow.propTypes = {
  row: PropTypes.object.isRequired,
  color: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  actionIcon: PropTypes.elementType,
  onHover: PropTypes.func,
};

export default SeatInventoryRow;
